// extracted by mini-css-extract-plugin
module.exports = {"cta":"petitions_cta__u8CHJ","ctaHeading":"petitions_ctaHeading__Bg_bj"};